/**
 * SyntheticEvent allow regular class to listen to events.
 * @class
 */
export default class SyntheticEvent {
    /**
     * Create a new SyntheticEvents container.
     * @param {...string} events - Recognized event names.
     */
    constructor(...events) {
        Object.fromEntries = arr => Object.assign({ }, ...Array.from(arr, ([k, v]) => ({ [k]: v })));
        this.events = Object.fromEntries(events.map(event => [event, []]));
    }

    /**
     * Add an event listener.
     * @public
     * @param {string} event          - Event name.
     * @param {eventHandler} callback - Event handler.
     * @return {function} cancel      - Function to remove event handler.
     */
    addEventListener(event, callback) {
        if (!(event in this.events)) {
            throw new Error(`Invalid event ${event}, valid events are ${Object.keys(this.events).join(', ')}`);
        }
        const eventID = this.events[event].length;
        this.events[event].push(callback);
        return () => {
            this.events[event] = this.events[event].slice(0, eventID)
                .concat(this.events[event].slice(eventID + 1));
        };
    }

    /**
     * Dispatch event through all event listeners.
     * @public
     * @param {string} event - Event name.
     * @param {...*} [args]  - Callback arguments.
     */
    dispatch(event, ...args) {
        if (!(event in this.events)) {
            throw new Error(`Invalid event ${event}, valid events are ${Object.keys(this.events).join(', ')}`);
        }
        this.events[event].forEach(callback => callback(...args));
    }
}
